import React from 'react';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Typography } from '@cp/ds/src/components/typography';
import { useConfig } from '@cp/shared/config';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { UserAgreementWidget } from 'src/widgets/legal';

export const UserAgreementContent = () => {
  const config = useConfig();
  const site = config.get('CLIENT_WEB_ORIGIN', '');

  return (
    <Container sx={{ mb: { xs: 4, md: 8 } }}>
      <Breadcrumbs
        LinkComponent={Link}
        items={[
          {
            path: '/',
            label: 'Главная',
          },
          {
            path: '',
            label: 'Пользовательское соглашение',
          },
        ]}
        sx={{ my: 2 }}
      />
      <Typography component="h3" sx={{ typography: { xs: 'h5', md: 'h3' } }}>
        Правила пользования сайтом и приложением
      </Typography>
      <Link href={`${site}/`}>{site}</Link>
      <UserAgreementWidget />
    </Container>
  );
};
